export const T = {
  en_GB: {
    edit: "Edit",
    delete: "Delete",
    productName: "Product Name",
    isin: "ISIN",
    instrument: "Instrument",
    active: "Active",
    actions: "Actions",
    viewAnalysis: "View analysis",
    notLinked: "Not linked",
    noProducts: "No products yet. Create your first product to get started.",
    noProductsMatch: "No products match your search",
    error: "Error",
    failedToUpdateStatus: "Failed to update product status",
    wrapperTypeMissing: "Wrapper type is missing",
    productsMissingWrapperTypes:
      "Some products are not assigned to any wrapper type. Open a product and pick its wrapper types on the Suitability tab.",
  },
  nb_NO: {
    edit: "Rediger",
    delete: "Slett",
    productName: "Produktnavn",
    isin: "ISIN",
    instrument: "Instrument",
    active: "Aktiv",
    actions: "Handlinger",
    viewAnalysis: "Se analyse",
    notLinked: "Ikke koblet",
    noProducts: "Ingen produkter ennå. Opprett ditt første produkt for å komme i gang.",
    noProductsMatch: "Ingen produkter samsvarer med søket",
    error: "Feil",
    failedToUpdateStatus: "Kunne ikke oppdatere produktstatus",
    wrapperTypeMissing: "Innpakningstype mangler",
    productsMissingWrapperTypes:
      "Noen produkter er ikke tilordnet noen innpakningstype. Åpne et produkt og velg innpakningstyper på Egnethet-fanen.",
  },
} as const;
